<li role="separator" class:bx--side-nav__divider="{true}" {...$$restProps}></li>
